/* unplugin-vue-components disabled */import { ElTag as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElForm as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElDatePicker as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("IOS玩家小票补单");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("补单日志");
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出数据");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("小票核查");
const _hoisted_6 = /*#__PURE__*/_createTextVNode("补单");
const _hoisted_7 = /*#__PURE__*/_createTextVNode("同步");
import CTable from '@ultra/share/components/CTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import dayjs from 'dayjs';
import { apiUsdkQueryOrders } from '@/api/usdk';
import { apiInternalGetPayTypes, apiInternalRepairOrder, apiInternalSyncOrder, apiUsdkProjectList } from '@/api/customerInternal';
import { useTaskStore } from '@/store/modules/downTask';
export default /*#__PURE__*/_defineComponent({
  props: {
    gameInfo: {
      type: Object,
      required: true
    },
    tableKey: {
      type: String
    },
    tableColumns: {
      type: Object
    }
  },
  emits: ['onActive', 'onIOSMidst'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const columns = [{
      label: 'ID',
      prop: 'id',
      isForce: true,
      isDefault: true
    }, {
      label: '登录名',
      prop: 'loginName',
      isDefault: true
    }, {
      label: '项目ID',
      prop: 'projectId'
    }, {
      label: '产品ID',
      prop: 'productId'
    }, {
      label: '产品名称',
      prop: 'productName',
      isDefault: true
    }, {
      label: '平台订单号',
      prop: 'cmgeOrderNum',
      isDefault: true
    }, {
      label: '第三方订单号',
      prop: 'thirdOrderNum',
      isDefault: true
    }, {
      label: '设备号',
      prop: 'deviceNum'
    }, {
      label: '下单时间',
      prop: 'submitTime',
      slot: 'submitTime'
    }, {
      label: '支付方式',
      prop: 'payTypeName'
    }, {
      label: '支付状态',
      prop: 'status',
      slot: 'status',
      isDefault: true
    }, {
      label: '同步状态',
      prop: 'syncStatus',
      slot: 'syncStatus',
      isDefault: true
    }, {
      label: '成交金额',
      prop: 'submitAmount',
      isDefault: true
    }, {
      label: '操作',
      prop: 'action',
      width: '200px',
      slot: 'action',
      isForce: true,
      isDefault: true
    }];
    const filter = ref({
      gid: props.gameInfo.Id,
      orderTime: [dayjs().subtract(7, 'days').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
      payStatus: undefined,
      syncStatus: undefined,
      projectId: undefined,
      payType: undefined,
      loginName: '',
      thirdOrderNum: '',
      cmgeOrderNum: ''
    });
    const createParams = () => {
      const {
        orderTime,
        payStatus,
        syncStatus,
        projectId,
        payType,
        loginName,
        cmgeOrderNum,
        thirdOrderNum,
        gid
      } = filter.value;
      const params = {
        gid,
        payStatus,
        syncStatus,
        projectId,
        payType,
        loginName: loginName || undefined,
        cmgeOrderNum: cmgeOrderNum || undefined,
        thirdOrderNum: thirdOrderNum || undefined,
        startDate: orderTime && orderTime.length ? dayjs(orderTime[0]).format('YYYY-MM-DD') : undefined,
        endDate: orderTime && orderTime.length ? dayjs(orderTime[1]).format('YYYY-MM-DD') : undefined
      };
      delete params.orderTime;
      return params;
    };
    // 获取订单服务列表
    const getTableData = () => {
      let params = createParams();
      tableLoading.value = true;
      apiUsdkQueryOrders({
        gid: props.gameInfo.Id,
        pageNum: current.value,
        pageSize: pageSize.value,
        area: 0,
        q: JSON.stringify(params)
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
          total.value = res.total;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    const handleClickItem = (type, data) => {
      if (type === 'check') {
        emits('onActive', 'internalTicketVer', data);
      } else if (type === 'sync') {
        ElMessageBox.confirm('是否确认同步？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            id: data.id
          };
          apiInternalSyncOrder(params).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
        }).catch(() => {
          console.log('取消');
        });
      } else {
        ElMessageBox.confirm('是否确认补单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            id: data.id
          };
          apiInternalRepairOrder(params).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
        }).catch(() => {
          console.log('取消');
        });
      }
    };
    const handleToRepairLog = () => {
      emits('onActive', 'repairLog');
    };
    const handleToIOSMidst = () => {
      emits('onIOSMidst', 'internal');
    };
    const {
      setTask
    } = useTaskStore();
    const exportTable = () => {
      let params = createParams();
      setTask({
        api: apiUsdkQueryOrders,
        page: 'pageNum',
        pageSize: 'pageSize',
        params: {
          gid: props.gameInfo.Id,
          area: 0,
          q: JSON.stringify(params)
        },
        data: 'data',
        total: 'total',
        excel: {
          title: `国内订单服务`,
          header: ['ID', '登录名', '项目ID', '产品ID', '产品名称', '平台订单号', '第三方订单号', '设备号', '下单时间', '支付方式', '支付状态', '同步状态', '成交金额'],
          field: ['id', 'loginName', 'projectId', 'productId', 'productName', 'cmgeOrderNum', 'thirdOrderNum', 'deviceNum', 'submitTime', 'payTypeName', 'status_Text', 'syncStatus_Text', 'submitAmount']
        }
      });
    };
    // 获取项目列表
    const projectList = ref([]);
    const getProjectList = () => {
      const params = {
        gid: props.gameInfo.Id
      };
      apiUsdkProjectList(params).then(res => {
        projectList.value = res.data || [];
      });
    };
    // 获取支付方式列表
    const payTypes = ref([]);
    const getPayTypes = () => {
      apiInternalGetPayTypes({}).then(res => {
        if (res.code === 0) {
          payTypes.value = res.data;
        }
      });
    };
    watch(() => props.gameInfo, val => {
      if (val && val.Id) {
        getTableData();
        getProjectList();
        getPayTypes();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_input = __unplugin_components_4;
      const _component_el_button = __unplugin_components_5;
      const _component_el_form = __unplugin_components_6;
      const _component_el_tag = __unplugin_components_7;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "下单时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: filter.value.orderTime,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filter.value.orderTime = $event),
            "end-placeholder": "结束时间",
            "range-separator": "至",
            "start-placeholder": "开始时间",
            type: "daterange"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "项目"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filter.value.projectId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filter.value.projectId = $event),
            clearable: "",
            placeholder: "请选择项目"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.projectId,
                label: item.projectName,
                value: item.projectId
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "支付状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filter.value.payStatus,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filter.value.payStatus = $event),
            clearable: "",
            placeholder: "请选择支付状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "成功",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "失败",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "退款",
              value: "2"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "同步状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filter.value.syncStatus,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filter.value.syncStatus = $event),
            clearable: "",
            placeholder: "请选择同步状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "成功",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "失败",
              value: "0"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "支付方式"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filter.value.payType,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filter.value.payType = $event),
            clearable: "",
            placeholder: "请选择支付方式"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payTypes.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.key,
                label: item.value,
                value: item.key
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "登录名"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.loginName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => filter.value.loginName = $event),
            placeholder: "请输入登录名"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "平台订单号"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.cmgeOrderNum,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => filter.value.cmgeOrderNum = $event),
            placeholder: "请输入平台订单号"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "第三方订单号"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: filter.value.thirdOrderNum,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => filter.value.thirdOrderNum = $event),
            placeholder: "请输入第三方订单号"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: getTableData
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(CTable, {
        "current-page": _unref(current),
        loading: _unref(tableLoading),
        "page-size": _unref(pageSize),
        "table-columns": columns,
        tableData: _unref(tableData),
        total: _unref(total),
        pagination: "",
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange)
      }, {
        top: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleToIOSMidst
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleToRepairLog
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "marginL10",
          type: "primary",
          onClick: exportTable
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        submitTime: _withCtx(({
          scope
        }) => [_createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatDate(scope.row.submitTime)), 1)]),
        status: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: scope.row.status === 0 || scope.row.status === 1 || scope.row.status === 19 ? 'success' : 'danger'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.status === 0 || scope.row.status === 1 || scope.row.status === 19 ? '成功' : scope.row.status === 2 ? '已退款' : '失败'), 1)]),
          _: 2
        }, 1032, ["type"])]),
        syncStatus: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: scope.row.syncStatus === 0 ? 'success' : 'danger'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.syncStatus === 0 ? '成功' : '失败'), 1)]),
          _: 2
        }, 1032, ["type"])]),
        action: _withCtx(({
          scope
        }) => [scope.row.type === 16 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          link: "",
          size: "small",
          type: "primary",
          onClick: $event => handleClickItem('check', scope.row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), scope.row.type == 16 && scope.row.status !== 0 && scope.row.status !== 1 && scope.row.status !== 19 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          link: "",
          size: "small",
          type: "primary",
          onClick: $event => handleClickItem('add', scope.row)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), scope.row.syncStatus !== 0 && (scope.row.syncStatus === 1 || scope.row.syncStatus === 19) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          link: "",
          size: "small",
          type: "primary",
          onClick: $event => handleClickItem('sync', scope.row)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["current-page", "loading", "page-size", "tableData", "total", "onSizeChange", "onCurrentChange"])], 64);
    };
  }
});